import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
// import { environment } from '@environments/environment';

import { MainModule } from './core/main/main.module';

import { HomeModule } from './modules/home/home.module';
import { LoginModule } from './modules/login/login.module';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { TonnageModule } from './modules/tonnage/tonnage.module';
import { TollModule } from './modules/toll/toll.module';
import { StatementsModule } from './modules/statements/statements.module';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getFrenchPaginatorIntl } from '@shared/paginator-intl';
import { UsersModule } from './modules/users/users.module';

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomerModule } from './modules/customer/customer.module';
import { SiteModule } from './modules/site/site.module';
import { RepositoryModule } from './modules/repository/repository.module';
import { AutocompleteObjectValidator } from '@shared/validators/autocomplete-object-validator';
import { MessageBoxModule } from '@components/message-box/message-box.module';
import { CoreModule } from './core/core.module';

import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ReportModule } from './modules/report/report.module';
import { BillingModule } from './modules/billing/billing.module';
import { ForgetPasswordModule } from './modules/forget-password/forget-password.module';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Configuration, EnvConfigurationService } from './core/services/env-configuration.service';
import { jwtOptions } from './core/jwt-utils';

// import { AgmCoreModule } from '@agm/core';

registerLocaleData(localeFr);

let environment: Configuration;

export function tokenGetter(): string {
  return localStorage.getItem(environment.tokenKey) || '';
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function GetAllowedDomains() {
  return environment.apiUrl;
}

export function GetDisallowedRoutes() {
  return environment.identityApiUrl;
}


export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,

    MessageBoxModule,

    CoreModule,
    BrowserAnimationsModule,
    MainModule,
    LoginModule,
    ForgetPasswordModule,
    HomeModule,
    TonnageModule,
    TollModule,
    StatementsModule,
    UsersModule,
    CustomerModule,
    SiteModule,
    RepositoryModule,
    ReportModule,
    BillingModule,


    AppRoutingModule,

    JwtModule.forRoot({
      //config: {
      //   tokenGetter,
      //   allowedDomains: [
      //     GetAllowedDomains()
      //   ],
      //   disallowedRoutes: [
      //     GetDisallowedRoutes()
      //   ]
      // }
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptions.options
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (envConfigService: EnvConfigurationService) => () => envConfigService
        .load()
        .then(() => {
          environment = envConfigService.environment
        }),
      deps: [EnvConfigurationService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide:
        MatPaginatorIntl,
      useValue: getFrenchPaginatorIntl()
    },
    AutocompleteObjectValidator,
    {
      provide: LOCALE_ID,
      useValue: 'fr-FR'
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_FORMATS
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
